import React from 'react';
import PropTypes from 'prop-types';

const SaveIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14">
        <g fill={fill}>
            <path d="M10.889 0H1.556A1.556 1.556 0 000 1.556v10.888A1.556 1.556 0 001.556 14h10.888A1.556 1.556 0 0014 12.444V3.111zM9.333 1.556v2.333H4.667V1.556zm3.111 10.889H1.556V1.556h1.556v3.889h7.778V2.2l1.556 1.556z" />
            <path d="M3.111 7h7.778v1.556H3.111z" />
            <path d="M3.111 9.333h7.778v1.556H3.111z" />
        </g>
    </svg>
);

SaveIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

SaveIcon.defaultProps = {
    width: '14',
    height: '14',
    fill: '#fff'
};

export default SaveIcon;
